// extracted by mini-css-extract-plugin
export default {"select-value":"SelectValue-module__select-value___tZ2iV"};